// https://www.figma.com/file/UnOBJd1UtkeEccupL0ZrYs/eatigo-APP?type=design&node-id=1-2000&mode=design&t=mFKQQ8HRjoBoz0db-0
export const colors = {
  red: {
    80: '#691117',
    70: '#931820',
    60: '#C21F2A',
    50: '#F32735',
    40: '#F5525D',
    30: '#F58184',
    20: '#FBB1B6',
    10: '#FDDDDF',
    '00': '#FEF5F6',
  },
  black: {
    80: '#000000',
    70: '#000000',
    60: '#0D0E0E',
    50: '#252729',
    40: '#3D4144',
    30: '#555A5F',
    20: '#6E7479',
  },
  gray: {
    80: '#747476',
    70: '#8E8E8F',
    60: '#A7A7A9',
    50: '#C1C1C2',
    40: '#DBDBDB',
    30: '#EDEDED',
    20: '#F4F4F5',
    10: '#FFFFFF',
  },
  white: '#FFFFFF',
  purple: {
    80: '#201F47',
    70: '#302F6A',
    60: '#403F8D',
    50: '#504FB0',
    40: '#7473C0',
    30: '#9695D0',
    20: '#B9B9DF',
    10: '#DCDCEF',
    '00': '#F1F1F9',
  },
  yellow: {
    80: '#6B4900',
    70: '#9E6C00',
    60: '#D18F00',
    50: '#FFB107',
    40: '#FFC038',
    30: '#FFD06B',
    20: '#FFE19E',
    10: '#FFF1D1',
    '00': '#FFF8EB',
  },
  green: {
    80: '#153D19',
    70: '#226329',
    60: '#2F8939',
    50: '#3CAE49',
    40: '#58C565',
    30: '#7ED388',
    20: '#A4E0AB',
    10: '#CAEDCE',
    '00': '#F0FAF1',
  },
  pinkish: {
    80: '#544545',
    70: '#705C5C',
    60: '#8C7373',
    50: '#A38F8F',
    40: '#BAABAB',
    30: '#D1C7C7',
    20: '#E8E3E3',
    10: '#F4F1F1',
  },
  orange: {
    80: '#A84D00',
    70: '#D16306',
    60: '#E86F07',
    50: '#F58220',
    40: '#F79B4D',
    30: '#F9B47A',
    20: '#FBD2AF',
    10: '#FDEBDC',
  },
  scarlet: {
    80: '#4D1A1C',
    70: '#73262A',
    60: '#993338',
    50: '#C03F45',
    40: '#CC666B',
    30: '#D98C90',
    20: '#E5B2B5',
    10: '#F2D9DA',
  },
  pink: {
    80: '#400C2A',
    70: '#6B1545',
    60: '#961D61',
    50: '#B00062',
    40: '#DA3E96',
    30: '#E269AE',
    20: '#EA94C5',
    10: '#F3BFDC',
    '00': '#FBEAF3',
  },
  blue: {
    80: '#000F14',
    70: '#003647',
    60: '#005D7A',
    50: '#0083AD',
    40: '#00AAE0',
    30: '#14C6FF',
    20: '#47D2FF',
    10: '#7ADFFF',
    '00': '#ADEBFF',
  },
  brown: {
    80: '#3C1F0C',
    70: '#663514',
    60: '#914B1D',
    50: '#BB6125',
    40: '#D87A3B',
    30: '#E19766',
    20: '#E9B490',
    10: '#F2D1BB',
    '00': '#FAEEE5',
  },
  fun: '#FF5537',
  googlegray: '#DADCE0',
} as const

export const screens = {
  sm: 600,
  md: 768,
  lg: 960,
  xl: 1280,
} as const

export const typography = {
  // https://github.com/unocss/unocss/blob/154e3a9aaa5407b12cdc55b6b3529d8dfb3400d8/packages/preset-mini/src/_theme/font.ts#LL40C21-L40C21
  // name: [font-size, line-height]
  '4xl': ['52px', '60px'],
  '3xl': ['36px', '44px'],
  '2xl': ['24px', '32px'],
  xl: ['20px', '28px'],
  lg: ['18px', '24px'],
  base: ['16px', '24px'],
  sm: ['14px', '20px'],
  xs: ['12px', '20px'],
} as const

export const zIndex = {
  popover: 2000,
  navbar: 2500,
  navbarCategories: 2700,
  modal: 3000,
  phoneVerificationHintModal: 3200,
  phoneVerificationModal: 3300,
  navbarPopover: 3600,
  drawer: 4000,
  loginModal: 4500,
  alert: 5000,
  fullPageLoading: 6000,
}

export default {
  screens,
  colors,
  typography,
  zIndex,
}
